/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RewardDto { 
    id?: number;
    type?: RewardDto.TypeEnum;
    value?: string;
}
export namespace RewardDto {
    export type TypeEnum = 'POINTS' | 'COUPON' | 'POINTS_PERCENTAGE';
    export const TypeEnum = {
        Points: 'POINTS' as TypeEnum,
        Coupon: 'COUPON' as TypeEnum,
        PointsPercentage: 'POINTS_PERCENTAGE' as TypeEnum
    };
}


